/**
 * رابط UpPromote في الموقع — يشير إلى موقع UpPromote الرسميّ.
 * المصدر الوحيد: UPPROMOTE_JOIN_URL؛ ممنوع كتابة رابط UpPromote حرفياً في أيّ ملفّ آخر.
 */
export const UPPROMOTE_JOIN_URL = "https://uppromote.com";

/**
 * إظهار UpPromote للزوّار — مُعطَّل بقرار جميل (20/09/2026) حتى تجهيز التكامل.
 * يتحكّم بقسم UpPromote في /ambassadors وفقرة المنصّات الخارجيّة (s12) في شروط السفراء.
 * التكامل الداخليّ (/admin/uppromote-import + webhook) يبقى كما هو بلا تأثير.
 * لإعادة الإظهار: غيّر القيمة إلى true فقط.
 */
export const SHOW_UPPROMOTE_PUBLIC = false;
